
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Trophy, Users } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';
import { useNavigate } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';

interface DashboardTabsProps {
  activeTab: string;
  onTabChange: (value: string) => void;
  children: React.ReactNode;
}

const DashboardTabs: React.FC<DashboardTabsProps> = ({ 
  activeTab, 
  onTabChange,
  children
}) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  
  return (
    <Tabs defaultValue={activeTab} value={activeTab} onValueChange={onTabChange}>
      <TabsList className="mb-6 gap-1 w-full flex justify-between">
        <TabsTrigger 
          value="overview" 
          className="flex-1 flex justify-center items-center"
        >
          {!isMobile ? "Overview" : "Overview"}
        </TabsTrigger>
        <TabsTrigger 
          value="leaderboard" 
          className="flex-1 flex justify-center items-center"
        >
          <Trophy className={isMobile ? "mr-0" : "mr-2"} size={isMobile ? 18 : 16} />
          {!isMobile && "Leaderboard"}
        </TabsTrigger>
        <TabsTrigger value="community" className="flex-1 flex justify-center items-center relative" disabled>
          <Users className={isMobile ? "mr-0" : "mr-2"} size={isMobile ? 18 : 16} />
          {!isMobile && "Community"}
          <Badge className={`bg-hormony-coral text-white text-[9px] ${isMobile ? "absolute -top-1 -right-1" : "ml-1"}`}>
            Soon
          </Badge>
        </TabsTrigger>
      </TabsList>
      
      {children}
    </Tabs>
  );
};

export default DashboardTabs;
